import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { LoadingFrame } from "@covertree/ui";
import { useContinueQuoteHandler } from "@hooks/actions/useContinueQuoteHandler";

export function SequoiaContinueLoading() {
  const { continueQuoteHandler } = useContinueQuoteHandler();
  const { policyLocator } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!policyLocator) navigate(-1);
    continueQuoteHandler(policyLocator);
  }, [continueQuoteHandler, policyLocator]);

  return (
    <LoadingFrame
      isFixed={true}
      image="/animations/spinner.gif"
      messages={[
        "Fetching Sequoia policy",
        "Fetching policy holder",
        "Finding applicable extra coverages",
        "Gathering underwriting rules",
        "Populating data into workflow",
        "Applying finishing touches",
      ]}
      maxLoadTime={10}
    />
  );
}
